<template>
    <div id="erro">
        <h1>Ops! Parece que essa página não existe :(</h1>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>